import styled from 'styled-components';

export const ElectedCoverageSettingsFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 30px;
  margin: 10px;
`;

export const ElectedCoverageEmptySettingsContainer = styled(ElectedCoverageSettingsFormContainer)`
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const FormItem = styled.div`
  flex-grow: 1;
  flex-basis: 0;
  flex-shrink: 1;

  padding: 10px;

  box-sizing: border-box;
`;

export const SubmitContainer = styled(FormItem)`
  display: flex;
  justify-content: space-between;
`;

export const InputContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-around;
`;

export const StyledEOIWrap = styled.p`
  padding-left: 0;
  margin-left: 0;
  min-height: 30px;
  padding: 0 16px;
  color: red;
`;
